<template>
  <footer class="footer bg-ternary">
    <div class="max-w-screen-xl mx-auto">
      <div class="md:mx-auto md:flex md:items-center md:justify-between">
        <div class="flex justify-between items-center">
          <div class="w-full text-right md:text-left text-base texto-roboto text-white">
            <div class="md:hidden pb-10 md:pb-0">
              <div>
                <router-link to="/privacy" class="a text-white uppercase">Privacy Policy</router-link>
              </div>
              <div>
                <router-link to="/terms" class="a ml-3 text-white uppercase">Terms & Conditions</router-link>
              </div>
            </div>
            <p>&copy; <span class="font-bold">{{ date }} GoldenRace</span></p>
            <p class="text-right md:text-left w-full">All rights reserved</p>
          </div>
        </div>
        <div class="hidden md:block">
          <router-link to="/privacy" class="a text-white uppercase">Privacy Policy</router-link>
          <router-link to="/terms" class="a ml-3 text-white uppercase">Terms & Conditions</router-link>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      date: new Date().getFullYear()
    }
  }
};
</script>

<style scoped>
.footer {
  padding: 1.5rem;
}

.a {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 170%;
  text-align: right;
  letter-spacing: 0.4px;
}
</style>